import React, { Component } from 'react';
import { Row, Col} from "reactstrap";
import twitter from "../img/twitter.png";

class Footer extends Component {
   
    render() {
        return (
            <Col lg={12} className="p-4 footer" style={{ background: "#333" }}>
            <Row>
              <Col
                md={4}
                lg={4}
                className="text-center text-white ml-auto mr-auto"
              >
                <h5 className="text-white">
                  <b>Devangel</b> <a href="https://twitter.com/devangelco" target="_blank"> <img className="twitter" src={twitter} alt="logo"/></a>
                </h5>
                &copy; 2020 &bull; All rights reserved
                <hr />
                <b>Made With  &lt;3 on the Blockchain</b>
                
              </Col>
            
            </Row>
          </Col>
        );
    }
}

Footer.propTypes = {

};

export default Footer;